var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 400,
    viewBox: "0 0 317.49 105.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.476 78.903h282.78l1.2448-0.17464s7.597-12.561-12.237-13.756c0 0-8.7835 0.10489-15.743 3.7564 0 0 5.4671-10.328-2.5383-16.063-8.0054-5.7352-15.891-3.5845-20.432-1.1948 0 0 8.8418-7.8859-3.2261-17.206-12.068-9.3201-38.049 3.1338-35.692 20.386 0 0-5.1729-7.4527-13.835-2.2097 0 0-6.5109-11.007-21.327-4.5547 0 0-1.3872 0.58512-0.58451-1.0201 0.80263-1.6053 4.647-11.346-7.4806-16.663-12.128-5.317-33.749 1.4134-32.144 21.775 0 0-11.886-12.694-19.055 3.914 0 0-0.1663 0.90175-1.3491-0.1121s-8.6576-8.7596-20.696-1.9191c0 0 5.9525-6.1917-1.5669-15.063-7.5194-8.8713-23.686-6.0951-31.714 1.9782 0 0-5.1334 3.8844-5.9101 16.012 0 0-5.0426-6.9224-12.393-3.4584s-6.759 6.5056-6.6745 11.237c0 0 0.25346 3.3795 1.1828 3.7175 0 0-7.8574-7.9418-13.94-5.9986 0 0-10.979 2.3128-6.6723 16.618z",
    fill: "#c2e9f7",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud2);
export default __webpack_public_path__ + "static/media/cloud2.039305e53e64910c9cdf069eb0ca3a81.svg";
export { ForwardRef as ReactComponent };